export class TemplateInputModel{
  title: string = '';
  templateId: number = -1;
}
